import Screen28896Home from '@/components/screen28896'

import MapStart from '@/components/screen28896/map-zone/mask/start'
import MapDetail from '@/components/screen28896/map-zone/mask/detail'
import MapParks from '@/components/screen28896/map-zone/mask/Control.vue'
import MapParksDetail from '@/components/screen28896/map-zone/mask/ControlDetail.vue'

export default {
  path: '/screen28896',
  component: Screen28896Home,
  children: [{
      path: '',
      component: MapStart
    },
    {
      path: 'towns/:id',
      component: MapDetail
    },
    {
      path: 'parks',
      component: MapParks
    },
    {
      path: 'parks/:town/:enterprise',
      component: MapParksDetail
    },

  ]
}



// WEBPACK FOOTER //
// ./src/router/screen28896.js